import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { stListIntels } from '../../../services/socialTradingService';

const RESOURCE = Resources.socialTradingIntel;

export const intelDataProvider: CustomDataProvider = {
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== RESOURCE) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }
    const { page = 1, perPage = 20 } = params.pagination || {};
    const filter = params.filter || {};
    const res = await stListIntels({
      type: String(filter.type || '').trim() || undefined,
      tag: String(filter.tag || '').trim() || undefined,
      intelId: String(filter.intelId || '').trim() || undefined,
      keyword: String(filter.keyword || '').trim() || undefined,
      language: String(filter.language || '').trim() || undefined,
      limit: perPage,
      offset: (page - 1) * perPage,
    });
    const items = res?.items || [];
    return {
      data: items.map((row) => ({ ...row, id: row.intelId })),
      total: res?.total ?? items.length,
    };
  },
};
